import script from "./PayoneerList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayoneerList.vue?vue&type=script&lang=ts&setup=true"

import "./PayoneerList.vue?vue&type=style&index=0&id=292339c4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292339c4"]])

export default __exports__